import React, { useState } from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import Modal from '~/commons/components/Modal.jsx';

const LinkPwdReset = () => {
  const [modal, setModal] = useState(false);

  return (
    <>
      <Modal
        show={modal}
        onHide={() => setModal(false)}
        size="sm"
      >
        <div className="form-row text-danger mb-3">
          <div className="col-auto">
            <FA icon={faExclamationCircle} />
          </div>
          <div className="col">
            注意：學生帳戶不能重設密碼<br/>
            請聯絡貴校負責老師跟進
          </div>
        </div>
        <button
          className="btn btn-primary btn-block"
          onClick={() => setModal(false)}
        >
          OK
        </button>
      </Modal>
      <a onClick={() => setModal(true)}>
        <small>忘記密碼?</small>
      </a>
    </>
  );
};

export default LinkPwdReset;
